import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getProject } from 'project/ducks/project';
import Meta from 'project/components/meta';
import { getProjectIdFromUrl } from 'project/utils';
import { getProjectEntriesState } from 'project/ducks/entries';

function mapStateToProps(state, { params, router }) {
  const projectID = getProjectIdFromUrl(params);

  return {
    projectID,
    project: getProject(state),
    categories: state.categories,
    projectSlug: params.pageSlug,
    subCategorySlug: params.subcategory,
    page: getProjectEntriesState(state).currentPage,
    router
  };
}

export default withRouter(connect(mapStateToProps)(Meta));



// WEBPACK FOOTER //
// ./project/containers/meta.jsx